import { getRequestScope } from "@/core/api-setup";

export default {
  props: {
    enableFindEnums: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enums: {
        paymentTypes: [],
        benefitTypes: []
      },
      rulesTypes: [
        {
          value: "COUPON_CODE",
          label: "Coupon Code"
        },
        {
          value: "CARD_BIN",
          label: "Card Bin"
        }
      ],
      benefitTypes: [
        {
          value: "DISCOUNT",
          label: "Discount"
        }
      ],
      benefitTypesLabels: {
        PERCENTAGE_DISCOUNT: "Percentage Discount",
        FIXED_AMOUNT_DISCOUNT: "Fixed Amount Discount"
      },
      benefitPaymentTypesLabels: {
        PAY_IN_FULL: "Pay in Full"
      }
    };
  },
  created() {
    if (this.enableFindEnums) {
      this.fetchEnums();
    }
  },
  methods: {
    getRuleTypeLabel(value) {
      return this.rulesTypes.find(type => type.value === value)?.label || "-";
    },

    getBenefitTypeLabel(value) {
      return this.benefitTypesLabels?.[value] || value;
    },

    async fetchEnums() {
      try {
        const apiScope = getRequestScope({ scopeName: "api" }, false, {
          proxyApi: false
        });
        const response = await apiScope.get(
          "/api/v1/promotionalcampaign/enums"
        );

        this.enums.paymentTypes = response.data.enums.paymentType.map(item => ({
          value: item,
          label: this.benefitPaymentTypesLabels?.[item] || item
        }));
        this.enums.benefitTypes = response.data.enums.benefitType.map(item => ({
          value: item,
          label: this.benefitTypesLabels?.[item] || item
        }));
      } catch (error) {
        console.error("Failed to fetch enums:", error);
      }
    }
  }
};
